import axiosClient from './axiosClient';

export const getTermAndCondition = () => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/terms`;
    return axiosClient.get(url);
};